export default __webpack_public_path__ + "407771dcb036dfae18da69035bcd30d2.png";